/**
 * App-boot refresh: mint a fresh access token from the HttpOnly refresh
 * cookie BEFORE React mounts, so a hard reload doesn't flash "signed out".
 *
 * Delegates to [refresh.ts] so this call shares an in-flight singleton with
 * the on-401 retry path in [api/client.ts] — without that, two parallel
 * /v1/auth/refresh calls would trip the family-revoke-on-reuse defence.
 */
import { refreshAccessToken } from './refresh';

export async function bootRefresh(): Promise<void> {
  await refreshAccessToken();
}
